import React from 'react'

import Tooltip from '../../../../../atoms/Tooltip'

import useStyles from './styles'

const CloseButtonIcon = React.forwardRef((props, ref) => (
  <svg
    ref={ref}
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <circle
      cx='12'
      cy='12'
      r='11'
      fill='#1F1F1F'
      stroke='#F5F6F8'
      strokeWidth='2'
    />
    <path
      d='M9 14.66L14.66 9'
      stroke='#C6C6C6'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M14.66 14.66L9 9'
      stroke='#C6C6C6'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
))

const CloseButton = ({ onDelete }) => {
  const classes = useStyles()

  return (
    <Tooltip
      title='Remove File'
      placement='right-start'
      classes={{ tooltipPlacementRight: classes.tooltip }}
    >
      <CloseButtonIcon
        onClick={e => {
          e.stopPropagation()
          onDelete()
        }}
        className={classes.root}
      />
    </Tooltip>
  )
}

export default CloseButton
